module.exports = __webpack_public_path__ + "img/pr.7c58faf6.svg";